import client from '@/apis/aniftyBackend/client';
import { Tag, TagResponse } from '@/apis/aniftyBackend/tags/interface';

const getTagsByName = async (keyword: string): Promise<Tag[]> => {
  const response = await client.get<TagResponse[]>(
    `api/tags/byName?keyword=${keyword}`
  );
  return response.data.map((value) => ({
    language: value.language,
    id: value.tagID,
    name: value.name,
    nameJA: value.nameJA,
  }));
};

export default getTagsByName;
